import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MenuModule } from 'primeng/menu'
import { ChipSelectorComponent } from './chip-selector.component'
import { ChipModule } from '@stantec/basin/chip'

@NgModule({
  declarations: [ChipSelectorComponent],
  imports: [CommonModule, MenuModule, ChipModule],
  exports: [ChipSelectorComponent],
})
export class ChipSelectorModule {}
